import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Exporting from 'highcharts/modules/exporting';
import Accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { default_options, fill_graph_crntyr, fill_graph_pcts, buildDateList } from './champlainFunctions';

HighchartsMore(Highcharts);
Exporting(Highcharts);
Accessibility(Highcharts);

const ChamplainGraph = (props) => { 
  const currentDataFile = 'https://nedews.nrcc.cornell.edu/vt/data/champlain_current.json';
  const dataFileName = 'https://nedews.nrcc.cornell.edu/vt/data/champlain_percentiles.json';
  const [ showDialog, setShowDialog ] = useState(false);
  const [ chart, setChart ] = useState(null);
  const [ datelist, setDatelist ] = useState([]);
  const [ options, ] = useState(default_options);
  
  // access to chart
  const afterChartCreated = (chart) => {
    setChart(chart);
    chart.showLoading();
  };

  const handleOpenDialog = () => { setShowDialog(true); };
  const handleCloseDialog = () => { setShowDialog(false); };

  useEffect(() => {
    if (!datelist.length) {
      setDatelist(buildDateList());
    } else {
      fill_graph_pcts(dataFileName, datelist, chart);
      fill_graph_crntyr(currentDataFile, datelist, chart);
      chart.hideLoading();
    }
    // eslint-disable-next-line
  }, [datelist]);

  return (
    <>
      <HighchartsReact
          highcharts={Highcharts}
          options={options}
          callback={afterChartCreated}
      />

      <div style={{paddingLeft:'1em'}}>
        <Button 
          variant="outlined"
          size="small"
          sx={{position:'absolute',right:"1em"}}
          onClick={handleOpenDialog}
        >
          About this product
        </Button>
      </div>
      
      <Dialog
        open={showDialog}
        onClose={handleCloseDialog}
        scroll='paper'
      >
        <DialogTitle>Lake Level Graphs</DialogTitle>
        <DialogContent>
          <p>The Lake Champlain Lake Level Graph is a product of the Northeast DEWS, based on daily data retrieved from the <a href="https://api.waterdata.usgs.gov" target="_blank" rel="noreferrer">USGS Water Data API</a>. </p>
          <p>The time series of measurements provided on the graph for the past year consists of both approved, quality-assured data (black dots) and provisional data (gray dots). The accuracy of provisional data has not been verified by the USGS.</p>
          <p>Percentiles on the graph are those corresponding to those used by the <a href="https://droughtmonitor.unl.edu/About/AbouttheData/DroughtClassification.aspx" target="_blank" rel="noreferrer">U.S. Drought Monitor</a>.</p>
          <p>The daily percentile values on the graph are based on all approved daily USGS measurements for the entire period of record (1907-present). The percentile calculations were performed using the <a href="https://numpy.org/doc/stable/reference/generated/numpy.percentile.html" target="_blank" rel="noreferrer">numpy percentile function</a>.</p>
          <p>USGS data are provided to meet the need for timely best science and on the condition that neither the USGS nor the U.S. Government shall be held liable for any damages resulting from the authorized or unauthorized use of the data.</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ChamplainGraph;
